



import { GtAdvertisement } from '@speedshop/template'

export default {
  name: 'Advertisement',
  components: {
    GtAdvertisement
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // data: {}
    }
  },
  async mounted() {
    // await this.init()
  },
  methods: {
    // async init() {
    //   if (this.noFresh) return
    //   const { path } = this.$route
    //   const lsName = path + '__ad'
    //   // 为了避免同一个页面二次请求的时候重新请求导致的刷新闪烁
    //   if (sessionStorage.getItem(lsName)) {
    //     this.data = JSON.parse(sessionStorage.getItem(lsName))
    //     return
    //   }
    //   const LandingPage = useLandingPage()
    //   await useLandingPage().getLandingData({
    //     pageUrl: path === '/' || !path ? '/page/home' : path,
    //     deviceType: this.$store.isMobile === true ? 'h5' : 'pc'
    //   })
    //   const adContent = await LandingPage?.advertFilter()
    //   sessionStorage.setItem(lsName, JSON.stringify(adContent))
    //   this.data = adContent
    // }
  }
}
